import { useContextSelector } from 'use-context-selector'
import { Avatar, MenuItem, Stack, Typography } from '@mui/material'

import { useApp } from '@hooks/app'
import { MemberProfileType } from '@type/member_profile_type'
import { ProfileEnum, ProfileEnumKeys } from '@enums/profile_enum'

import { ProfileSwitcherContext } from '../context'
import { ProfileSwitcherHead } from './profile-switcher-head'
import { formatInitials } from '@utils/formatter'
import { theme } from '@theme/index'

type Props = {
  profile: ProfileEnumKeys
  members: MemberProfileType[]
}

export const ProfileSwitcherItemsInterface = (props: Props): JSX.Element => {
  const { selectedProfile, handleSelectProfile } = useApp()

  const handleClose = useContextSelector(
    ProfileSwitcherContext,
    (s) => s.handleClose
  )

  if (props.members.length === 0) return <></>

  return (
    <Stack direction="column">
      <ProfileSwitcherHead label={ProfileEnum[props.profile]} />
      {props.members.map((member) => {
        const selected = member.value?.id === selectedProfile?.value?.id
        return (
          <MenuItem
            key={`member-${member.value?.id}`}
            sx={{ py: 2, px: 1.5, opacity: '1 !important' }}
            disabled={selected}
            onClick={() => {
              handleClose()
              handleSelectProfile(member)
            }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              width="100%"
              px={0.5}
              py={0.5}
              pr={1}
              borderRadius={1}
              sx={{
                backgroundColor: selected
                  ? theme.palette.muted.light
                  : 'transparent',
              }}
            >
              <Avatar
                variant="rounded"
                sx={{ width: 21, height: 21, fontSize: 11 }}
                children={formatInitials(member?.label || 'unknown')}
              ></Avatar>
              <Typography
                variant="caption"
                color="primary"
                fontSize={12}
                lineHeight={0}
                sx={{ color: theme.palette.muted.dark }}
              >
                {member.label}
              </Typography>
            </Stack>
          </MenuItem>
        )
      })}
    </Stack>
  )
}
